(() => {
  if (window.__glNavigationTracking) return;
  window.__glNavigationTracking = true;
  const script = document.currentScript;
  const key = 'gl_navigation_path_v1';
  const lifetime = 30 * 60 * 1000;
  let productReported = false;
  let contextReported = false;
  const sources = new Set(['header', 'category_tree', 'mobile_menu', 'search_results', 'search_suggestions']);

  function allowed() {
    try {
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
    } catch {
      return false;
    }
  }

  function clearIfDenied() {
    try {
      if (window.Shopify?.customerPrivacy?.currentVisitorConsent?.().analytics === 'no') clear();
    } catch {}
  }

  function clear() {
    try { window.sessionStorage.removeItem(key); } catch {}
  }

  function context() {
    if (!allowed()) { clearIfDenied(); return null; }
    try {
      const value = JSON.parse(window.sessionStorage.getItem(key));
      if (!value || !sources.has(value.navigation_source) || Date.now() - value.timestamp > lifetime) {
        clear();
        return null;
      }
      return value;
    } catch { return null; }
  }

  function remember(source) {
    const value = { navigation_source: source, timestamp: Date.now() };
    if (allowed()) {
      try { window.sessionStorage.setItem(key, JSON.stringify(value)); } catch {}
    }
    return value;
  }

  function publish(name, data) {
    if (!allowed() || typeof window.Shopify?.analytics?.publish !== 'function') return false;
    try {
      const result = window.Shopify.analytics.publish(name, {
        ...data,
        page_type: script?.dataset.pageType || '',
        device_type: window.matchMedia('(max-width: 719px)').matches ? 'mobile' : 'desktop',
        measurement_environment: window.Shopify?.theme?.role === 'main' ? 'live' : 'preview',
        theme_id: script?.dataset.themeId || ''
      });
      if (result?.catch) result.catch(() => {});
      return true;
    } catch { return false; }
  }

  function getSource(element, destination) {
    if (element.closest('.search-flydown, [data-live-search-results], [data-predictive-search]')) return 'search_suggestions';
    if (script?.dataset.pageType === 'search' && /\/products\//.test(destination.pathname)) return 'search_results';
    if (element.closest('.custom-sidebar, .productgrid--sidebar-menu')) return 'category_tree';
    if (element.closest('.site-mobile-nav')) return 'mobile_menu';
    if (element.closest('[data-site-navigation], .site-header')) return 'header';
    return '';
  }

  function clicked(event) {
    if (!allowed()) { clearIfDenied(); return; }
    const anchor = event.target?.closest?.('a[href]');
    if (!anchor) return;
    let destination;
    try { destination = new URL(anchor.href, window.location.href); } catch { return; }
    if (destination.origin !== window.location.origin || !/\/(collections|products|pages|search)(\/|$)/.test(destination.pathname)) return;
    if (destination.pathname === window.location.pathname && destination.hash) return;
    const source = getSource(anchor, destination);
    if (!source) return;
    remember(source);
    publish('gl_navigation_clicked', {
      navigation_source: source,
      source_path: window.location.pathname,
      target_path: destination.pathname,
      target_type: /\/products\//.test(destination.pathname) ? 'product' : /\/collections\//.test(destination.pathname) ? 'collection' : 'other'
    });
  }

  function submitted(event) {
    if (!allowed()) { clearIfDenied(); return; }
    const form = event.target;
    if (!form?.matches?.('form')) return;
    let destination;
    try { destination = new URL(form.action, window.location.href); } catch { return; }
    if (destination.origin !== window.location.origin || !/\/search\/?$/.test(destination.pathname)) return;
    if (!form.querySelector('input[name="q"]')?.value?.trim()) return;
    remember('search_results');
    publish('gl_search_submitted', { navigation_source: 'search_results', source_path: window.location.pathname });
  }

  function pageReady() {
    if (!allowed()) { clearIfDenied(); return; }
    if (document.referrer) {
      try { if (new URL(document.referrer).origin !== window.location.origin) clear(); } catch {}
    }
    const path = context();
    const payload = {
      navigation_source: path?.navigation_source || 'unattributed',
      source_timestamp: path?.timestamp || 0,
      page_path: window.location.pathname
    };
    if (!contextReported) contextReported = publish('gl_navigation_context', payload);
    if (!productReported && script?.dataset.pageType === 'product') {
      productReported = publish('gl_product_entry', { ...payload, product_id: script.dataset.productId || '' });
    }
  }

  document.addEventListener('click', clicked, true);
  document.addEventListener('auxclick', event => { if (event.button === 1) clicked(event); }, true);
  document.addEventListener('submit', submitted, true);
  document.addEventListener('trackingConsentAccepted', pageReady);
  document.addEventListener('visitorConsentCollected', () => {
    if (!allowed()) { clear(); productReported = false; contextReported = false; }
    else pageReady();
  });
  window.addEventListener('pageshow', pageReady);
  pageReady();
  let attempts = 0;
  const timer = window.setInterval(() => {
    pageReady();
    attempts += 1;
    if (contextReported || attempts >= 12) window.clearInterval(timer);
  }, 500);
})();
